<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item" @click="goToRoute('/overview')">
      <a
        class="nav-link"
        :class="{ active: $route.path.includes('/overview') }"
        style="cursor: pointer"
      >
        <span class="nav-link-text" style="text-transform: none">Inicio</span>
      </a>
    </li>
    <li class="nav-item" @click="goToRoute('/postulation')">
      <a
        class="nav-link"
        :class="{
          active:
            $route.path.includes('/postulation') ||
            $route.path == '/postulation',
        }"
        style="cursor: pointer"
      >
        <span class="nav-link-text" style="text-transform: none"
          >Mis postulaciones</span
        >
      </a>
    </li>
    <li class="nav-item" @click="goToRoute('/my-payments')">
      <a
        class="nav-link"
        :class="{
          active:
            $route.path.includes('/my-payments') ||
            $route.path == '/my-payments',
        }"
        style="cursor: pointer"
      >
        <span class="nav-link-text" style="text-transform: none"
          >Mis pagos</span
        >
      </a>
    </li>
    <li class="nav-item" @click="goToRoute('/profile')">
      <a
        class="nav-link"
        :class="{
          active: $route.path.includes('/profile') || $route.path == '/profile',
        }"
        style="cursor: pointer"
      >
        <span class="nav-link-text" style="text-transform: none">Mi perfil</span>
      </a>
    </li>
    <li
      v-if="isTrainerAndFormerPlayer || isTrainer"
      class="nav-item"
      @click="goToURL('https://www.conmebol.com/entrenadores-con-licencia-conmebol/')"
    >
      <a class="nav-link" style="cursor: pointer">
        <span class="nav-link-text" style="text-transform: none">Conmebol</span>
      </a>
    </li>
    <li
      v-if="isTrainerAndFormerPlayer || isTrainer"
      class="nav-item"
      @click="goToURL('https://entrenadores.federacionvenezolanafutbol.com/iniciar_sesion')"
    >
      <a class="nav-link" style="cursor: pointer">
        <span class="nav-link-text" style="text-transform: none">RNE</span>
      </a>
    </li>
    <li class="nav-item mt-3" @click="closeSession">
      <a class="nav-link" style="cursor: pointer">
        <span class="nav-link-text text-danger" style="text-transform: none"
          >Cerrar sesión</span
        >
      </a>
    </li>
  </ul>
</template>
<script>
import { mapActions } from "vuex";
import Cookies from "js-cookie";

export default {
  name: "mobile-menu",
  computed: {
    isUser() {
      return this.id_type_user == 0;
    },
    isTrainer() {
      return this.id_type_user == 1;
    },
    isFormerPlayer() {
      return this.id_type_user == 2;
    },
    isTrainerAndFormerPlayer() {
      return this.id_type_user == 3;
    },
  },
  data() {
    return {
      id_type_user: Cookies.get("id_type_user"),
    };
  },
  methods: {
    ...mapActions(["logout"]),
    goToRoute(route) {
      this.$router.push(route);
    },
    goToURL(url) {
      window.open(url, "_blank");
    },
    closeSession() {
      this.logout();
      location.reload();
    },
  },
};
</script>
<style>
</style>
